
<div class="popup-aside-plain">
  <div class="popup-takeResa">
    <div v-if="formIsEmpty" class="nav-toggle" @click="closePopup">
      <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
    </div>
    <el-popover placement="right" width="200" v-model="popupValidClose" popper-class="popup-delete black-inputs">
      <p>Êtes vous sûr de vouloir arrêter la prise de réservation</p>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" class="dark" type="primary" @click="popupValidClose = false">Annuler</el-button>
        <el-button type="primary" size="mini" @click="closePopup">Confirmer</el-button>
      </div>
      <div v-if="!formIsEmpty" class="nav-toggle" slot="reference" @click="popupValidClose = true">
        <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
      </div>
    </el-popover>
    <div class="nav-step">
      <div v-if='formPart1.show'>Etape 1/2</div>
      <div v-if='formPart2.show'>Etape 2/2</div>
    </div>
    <el-row class="black-inputs">
      <el-col :span="20" :offset="2" v-if="formPart1.show">
        <el-form ref="formPart1.data" :rules="rulesFormPart1" :model="formPart1.data" label-width="0px">
          <el-form-item class="civ">
            <el-radio-group v-model="formPart1.data.civ">
              <el-radio-button label="M."></el-radio-button>
              <el-radio-button label="Mme"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="name">
            <el-autocomplete v-model="formPart1.data.name" placeholder="Nom*" :fetch-suggestions="querySearchName"
              :trigger-on-focus="false" @select="handleSelectClient">
              <template slot-scope="{ item }">
                <span class="autocomp-name">{{ item.name }} </span>
                <span class="autocomp-prenom">{{ item.prenom }}</span>
                <span class="autocomp-show" v-if='item.countShow > 1'>{{ item.countShow }}</span>
                <span class="autocomp-star" v-if='item.countShow > 0'></span>
                <span class="autocomp-noshow" v-if='item.countNoShow > 1'>{{ item.countNoShow }}</span>
                <span class="autocomp-thumb-down" v-if='item.countNoShow > 0'></span>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item prop="prenom">
            <el-input v-model="formPart1.data.prenom" placeholder="Prénom*"></el-input>
          </el-form-item>
          <el-form-item prop="telPreFix" class="tel-prefix">
            <el-input v-model="formPart1.data.telPreFix" placeholder="+33"></el-input>
          </el-form-item>
          <el-form-item prop="tel" class="tel">
            <el-input v-model="formPart1.data.tel" @input="formPart1.errorContact = false"
              placeholder="Téléphone"></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <div class="popup-takeResa-link" v-if="!showEmail" @click="showEmail = true">Avez-vous un email ?</div>
            <el-input v-if="showEmail" v-model="formPart1.data.email" placeholder="e-mail"
              @input="forceLowerCase(); formPart1.errorContact = false"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formPart1.data.societe" placeholder="Société"></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-input v-model="formPart1.data.comment" :autosize="{ minRows: 3 }" type="textarea"
              placeholder="Commentaire concernant le client"></el-input>
          </el-form-item> -->
          <el-form-item v-if="formPart1.errorContact">
            <div class="errorContact">Merci de renseigner soit une adresse mail soit un numero de téléphone</div>
          </el-form-item>
          <el-form-item v-loading="formPart1.loading">
            <el-button type="primary" v-if="!formPart1.loading"
              @click="onSubmitPart1('formPart1.data')">Valider</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="18" :offset="3" v-if="formPart2.show" v-loading="formPart2.loading">
        <el-form ref="formPart2.data" :rules="rulesFormPart2" :model="formPart2.data" label-width="120px">
          <el-form-item>
            <calendar-nav />
          </el-form-item>
          <el-form-item>
            <div class="popup-takeResa_numberInput-left"><i @click="formPart2.data.nbCouvert--; checkValues()"
                class="el-icon-minus"></i></div>
            <el-input @focus="focusNumber" @change="checkValues" type="number"
              class="text-centered popup-takeResa_numberInput" size="medium" :min="1"
              v-model="formPart2.data.nbCouvert">
            </el-input>
            <div class="popup-takeResa_numberInput-right"><i @click="formPart2.data.nbCouvert++; checkValues()"
                class="el-icon-plus"></i></div>
          </el-form-item>
          <el-form-item>
            <el-select v-if="getSelectedDayServicesData !== null" class="text-centered" v-model="selectedService"
              @change="msServiceChange" value-key="id" placeholder="Choisissez un service">
              <el-option v-for="item in getSelectedDayServicesData" :key="item.id" :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="selectedService && getServicesHoursData">
            <div class="popup-takeResa-dayClosed" v-if="getServicesHours === null">Fermé</div>
            <el-select
              v-if="getServicesHours !== null && getServicesHoursData !== null && getServicesHoursData[selectedService.ms]"
              class="text-centered" v-model="formPart2.data.date2" value-key="id" @change="serviceChange"
              placeholder="Choisissez une heure">
              <el-option v-for="h in getServicesHoursData[selectedService.ms].tab" :key="h.id" :label="h.hour"
                :value="h">
                <span class="spanModified" :style="{ color: h.color }">
                  {{ h.label }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="getCashInfos && getCashInfosData && (!this.cashInfos.nbCouv || parseInt(this.cashInfos.nbCouv) <= parseInt(this.formPart2.data.nbCouvert))">
            {{ cashInfos.type }} de {{ cashInfos.value }}€/c soit {{ Math.round((cashInfos.value *
              formPart2.data.nbCouvert)
              * 100) /
              100 }}€ CB ->
            <el-switch v-model="cashProceed" active-color="#00cec0" inactive-color="#e95d5d">
            </el-switch>
          </el-form-item>
          <el-form-item class="popup-takeResa-allergen" prop="allergen">
            <el-radio-group v-model="formPart2.data.allergen" @change="btnTakeResaDisable = false">
              <el-radio style="white-space: normal; padding:5px 10px" :label="false">Aucune intolérance ou allergie
                <br>pour
                l’ensemble des convives</el-radio>
              <el-radio style="white-space: normal; padding:5px 10px" :label="true">Intolérance / Allergie </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="formPart2.data.allergen" prop="allergenMessage">
            <el-input v-model="formPart2.data.allergenMessage" :autosize="{ minRows: 3 }"
              @blur="btnTakeResaDisable = false" type="textarea"
              placeholder="Merci de renseigner les intolérances / allergies"></el-input>
          </el-form-item>
          <el-form-item prop="preFix" class="rPrefix">
            <el-input v-model="formPart2.data.preFix" placeholder="Préfixe (4 lettres max.)" maxlength="4"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formPart2.data.commentResa" :autosize="{ minRows: 3 }" type="textarea"
              placeholder="Commentaire concernant la réservation"></el-input>
          </el-form-item>
          <el-form-item prop="preFixServ" class="rPrefix">
            <el-input v-model="formPart2.data.preFixServ" placeholder="Interne (4 lettres max.)"
              maxlength="4"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="popup-takeResa-rgpd">
              <div>Offres promotionnelles (rgpd) :</div>
              <div class="checkboxes">
                <el-checkbox v-model="formPart2.data.rgpdmail">E-mail</el-checkbox>
                <el-checkbox v-model="formPart2.data.rgpdsms">SMS</el-checkbox>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-if="getDiscountAmount">
            <div class="popup-takeResa-promotion">
              <div>Réduction :</div>
              <div class="checkboxes">
                <el-checkbox v-model="formPart2.data.discount">Activer la réduction de <span class="promo">{{
                  getDiscountAmount }}%</span></el-checkbox>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-button class="dark" type="primary" @click="switchForm">Précédent</el-button>
              </el-col>
              <el-col :span="12">
                <el-button :disabled="btnTakeResaDisable" type="primary"
                  @click="onSubmitPart2('formPart2.data')">Réserver</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</div>
